module.exports = __webpack_public_path__ + "static/media/hospmang2.df0adcea.png";